import { translation } from "../../../helper/translation"

export const ContentHomePageHeading = ({breadcrumb}:{breadcrumb:string}) => {
    return(
        <div className="page-heading">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 header-text">
                    <h2>{translation("header-data-driven")}</h2>
                    <p>{translation("under-header-data-driven")}</p>
                    </div>
                </div>
            </div>
            <div className="breadcrumb">
                <span>{translation("you-are-here")}: </span>
                <span>{breadcrumb}</span>
            </div>
        </div>
    )
}